import React from 'react';
import Tag from 'features/issues/components/Tag';

export { Tag };

/**
 * Class colour says what kind of problem it is at a glance:
 *   broken (red) · slow or throttled (amber) · rejected (blue) · other (grey).
 */
const TONE = {
  http_5xx: 'error', connection: 'error', code: 'error',
  timeout: 'warning', rate_limit: 'warning',
  auth: 'info', refused: 'info', validation: 'info', not_found: 'info',
};

/** Class tag, then the error type the trace recorded (and a status code, if any). */
export default function FailureTags({ cluster, statusCode, wrap = true }) {
  return (
    <div className={`flex min-w-0 items-center gap-1 ${wrap ? 'flex-wrap' : 'flex-nowrap overflow-hidden'}`}>
      <Tag tone={TONE[cluster.error_class] || 'neutral'}>{cluster.error_class_label}</Tag>
      {cluster.error_type ? <Tag mono title="Error type">{cluster.error_type}</Tag> : null}
      {statusCode ? <Tag mono title="Status code">{statusCode}</Tag> : null}
    </div>
  );
}
